import * as React from 'react'
import {observer} from 'mobx-react'
import {useStores} from '../../../../lib/MobXProvider'
import {RippleWrapper} from '../../../wrappers/RippleWrapper'
import {WidgetApi} from '../../../../lib/WidgetApi'

///////////////////////////////////////////////////////////////////////////////

export const PaymentSubmitBlock = observer(() => {
  const {api} = useStores<{api: WidgetApi}>()
  const showSubmitButton = api.resolveConfigWithSingleResult<boolean>(
    'showSubmitButton',
  )
  const {uiTransitionTimeout: timeout} = api.computedConfig

  if (!showSubmitButton) {
    return null
  }

  const submit = () => {
    setTimeout(() => {
      api.paymentForm.validateAndSend()
    }, timeout)
  }

  const headerTextHTML = api.trans('blocks.payment_submit.header_text_html', {
    defaultValue: null,
  })
  const footerTextHTML = api.trans('blocks.payment_submit.footer_text_html', {
    defaultValue: null,
  })

  return (
    <div className="widget-block payment-submit-block">
      <div className="payment-submit">
        {headerTextHTML && (
          <div
            className="header"
            dangerouslySetInnerHTML={{__html: headerTextHTML}}
          />
        )}
        <div className="main">
          <RippleWrapper>
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={submit}
            >
              <span className="btn-text">
                {api.trans('blocks.payment_submit.submit')}
              </span>
            </button>
          </RippleWrapper>
        </div>
        {footerTextHTML && (
          <div
            className="footer"
            dangerouslySetInnerHTML={{__html: footerTextHTML}}
          />
        )}
      </div>
    </div>
  )
})
